import { Menu, PanelLeft } from 'lucide-react';
import { useAuth } from '../../context/AuthProvider';
import RoleSwitcher from '../common/RoleSwitcher';

export default function AdminHeader({ toggleMobileSidebar, toggleCollapse, collapsed }) {
  const { logout } = useAuth();

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between pt-6 pr-6 pb-1 pl-6 bg-white lg:pl-0">
      <div className="hidden p-2 mr-3 lg:block">
        <PanelLeft
          className={`text-[#7a7c7c] cursor-pointer ${
            collapsed ? 'block' : 'hidden'
          }`}
          onClick={toggleCollapse}
        />
      </div>
      <div className="flex items-center justify-between w-full gap-3">
        {/* Mobile menu button */}
        <button className="lg:hidden" onClick={toggleMobileSidebar}>
          <Menu className="text-[#7a7c7c]" />
        </button>
      </div>
      <div className="flex items-center gap-3">
        <RoleSwitcher />
        <button
          className="px-4 py-[4px] font-medium text-[#002231] border-2 border-[#CCCCCC] rounded"
          onClick={logout}
        >
          Logout
        </button>
      </div>
    </header>
  );
}

